import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.MANAGE_COOKIES,
  getComponent: async function (nextState, cb) {
    const module = await import('./ManageCookiesContainer')
    cb(null, module.default)
  }
})
